import BaseView from './BaseView';

let view = null;

class ExampleView extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		/*
		Voorbeeld van component toevoegen:

		this.container.querySelectorAll('[data-example-component]').forEach((component) => {
			this.components.push(new ExampleComponent(component));
		});

		Voorbeeld van event listener toevoegen:
		
		this.addListener(document, 'scroll', this.handleScroll);
		*/
	}

	destroy() {
		super.destroy();
	}
}

export default {
	namespace: 'page-default',
	beforeEnter: ({ current, next, trigger }) => {
		view = new ExampleView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
